import { Link } from "react-router-dom";

const PrivacyNote = ({ center = false }) => (
  <p data-testid="privacy-note" className={`mt-4 text-xs leading-relaxed text-ink/50 ${center ? "text-center" : ""}`}>
    We respect your privacy — see{" "}
    <Link
      to="/privacy"
      data-testid="privacy-note-link"
      className="underline underline-offset-2 transition-colors hover:text-terra-500"
    >
      how your information is handled
    </Link>
    .
  </p>
);

export default PrivacyNote;
